import axios from "axios";
import moment from "moment-timezone";
import CONSTANTS from "../shared/constants";
export const api = getApi();

export function getApi() {
  // Overridable so this is not one developer's VM: set REACT_APP_API_URL to your
  // own backend to run the app locally. The default is unchanged.
  const MYLOCAL =
    process.env.REACT_APP_API_URL || "https://be.krichey.vm.cinch.io";

  const baseUrl =
    CONSTANTS.ENV === "LOCAL"
      ? MYLOCAL
      : CONSTANTS.ENV === "DEV"
      ? "https://engine-dev.cinch.io"
      : "https://engine.cinch.io";

  try {
    return axios.create({
      baseURL: baseUrl,
      headers: {
        "content-type": "application/json",
      },
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        for (const key of Object.keys(params)) {
          let param = params[key];
          if (Array.isArray(param)) {
            param = param.join(",");
          }

          if (param instanceof Date || param instanceof moment) {
            param = param.toISOString();
          }

          if (param instanceof moment) {
            param = param.toISOString();
          }

          if (param !== undefined && param !== null && param !== "") {
            searchParams.append(key, param);
          }
        }
        return searchParams.toString();
      },
    });
  } catch (error) {
    console.log("Error creating axios instance", error);
    console.log("Error creating axios instance response", error?.response);
    console.log("Error creating axios instance data", error?.response.data);

    return;
  }
}
export const unwrap = ({ data }) => data;

export function buildQueryParams(params) {
  return params
    ? `?${Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join("&")}`
    : "";
}
